export default "__VITE_ASSET__CyBVmNSj__"